// extracted by mini-css-extract-plugin
module.exports = {"postCardGrid":"PostCardGrid_postCardGrid__kFbY9","searchBar":"PostCardGrid_searchBar__3LFuD","grid":"PostCardGrid_grid__3xWFT"};